import React from 'react';
import { RICOS_FONT_SIZE_TYPE } from 'ricos-content';
import { Decoration_Type } from 'ricos-schema';
import type { EditorCommands, TiptapEditorPlugin } from 'ricos-types';
import { createShortcut } from 'ricos-types';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';

import { FONT_SIZE_BUTTON_DATA_HOOK } from './data-hooks';
import { fontSize } from './extension';
import FontSizePanelComponent from './FontSizePanelComponent';

const FONT_SIZE_MODAL_ID = `${Decoration_Type.FONT_SIZE}.modal`;

const getFontSize = (editorCommands: EditorCommands): ((props) => JSX.Element) => {
  const currentFontSize = editorCommands.getFontSize() || '';
  return () => <div>{currentFontSize}</div>;
};

export const pluginFontSize: TiptapEditorPlugin = {
  type: Decoration_Type.FONT_SIZE,
  config: {},
  tiptapExtensions: [fontSize],
  shortcuts: [
    createShortcut({
      name: `${Decoration_Type.FONT_SIZE}.increase`,
      description: 'ShortcutsSheet_Formatting_IncreaseFontSize',
      keys: { macOs: 'Meta+Alt+.', windows: 'Ctrl+Alt+.' },
      command({ editorCommands }) {
        const currentFontSize = editorCommands.getFontSize();
        const newFontSize = currentFontSize && parseInt(currentFontSize, 10) + 1;
        if (newFontSize) {
          editorCommands.insertDecoration(RICOS_FONT_SIZE_TYPE, {
            fontSize: newFontSize.toString(),
          });
        }
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
    createShortcut({
      name: `${Decoration_Type.FONT_SIZE}.decrease`,
      description: 'ShortcutsSheet_Formatting_DecreaseFontSize',
      keys: { macOs: 'Meta+Alt+,', windows: 'Ctrl+Alt+,' },
      command({ editorCommands }) {
        const currentFontSize = editorCommands.getFontSize();
        const newFontSize = currentFontSize && parseInt(currentFontSize, 10) - 1;
        if (newFontSize) {
          editorCommands.insertDecoration(RICOS_FONT_SIZE_TYPE, {
            fontSize: newFontSize.toString(),
          });
        }
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  textButtons: [
    {
      id: Decoration_Type.FONT_SIZE,
      type: 'modal',
      presentation: {
        dataHook: FONT_SIZE_BUTTON_DATA_HOOK,
        tooltip: 'FormattingToolbar_CustomFontSizeButton_Tooltip',
        getIcon: getFontSize,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        selectedFontSize: RESOLVERS_IDS.GET_FONT_SIZE_IN_SELECTION,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED,
      },
      modal: {
        id: FONT_SIZE_MODAL_ID,
        Component: FontSizePanelComponent,
        autoFocus: false,
      },
    },
  ],
};
